import React from "react";
import { UncontrolledTooltip } from "reactstrap";

const SHIPPING_TYPES = {
  Magento: {value: 1, label: "Magento"},
  Acumatica: {value: 2, label: "Acumatica"}
};

export default {
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  daysInMonth: (month, year) => {
    return new Date(year, month, 0).getDate();
  },
  UCToolTip: props => {
    return (
      <UncontrolledTooltip
        placement={props.placement}
        target={props.target}
        data-html="true"
      >
        {props.text}
      </UncontrolledTooltip>
    );
  },
  uploadType: {
    shipping: "Shipping",
    production: "Production",
    product: "Product",
    productionHistorical: "Production Historical Bulk",
    shippingHistorical: "Shipping Historical Bulk",
    equipmentDocument: "Equipment Document",
    part: "Part",
    inventory: "Inventory"
  },
  notificationType: {
    email: 1
  },
  calibrationType: {
    range: "Range",
    manual: "Manual",
    tbd: "TBD"
  },
  maintenanceType: {
    Calibration: { name: "Calibration", id: 1 },
    Maintenance: { name: "Maintenance", id: 2 }
  },
  AdminToken: "cbdmdAdminToken",
  AdminUser: "cbdmdAdminUser",
  CurrentUser: "currentUser",
  Token: "token",
  inventorySearchType: {
    both: {
      name: "Both",
      id: 0
    },
    products: {
      name: "Products",
      id: 1
    },
    parts: {
      name: "Parts",
      id: 2
    }
  },
  mimeTypes: {
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  },
  url: {
    ProductPartTypeaheadUrl: "Warehouse/ProductPartTypeahead"
  },
  warehouseArea: {
    Rows: { NumberOfBays: 17, BinsPerBay: 8 },
    Picks: { NumberOfBays: 9, BinsPerBay: 5 },
    Oils: { NumberOfBays: 1, BinsPerBay: 1 }
  },
  ArrowUpKey: "ArrowUp",
  ArrowDownKey: "ArrowDown",
  ArrowLeftKey: "ArrowLeft",
  ArrowRightKey: "ArrowRight",
  EnterKey: "Enter",
  EscapeKey: "Escape",
  TabKey: "Tab",
  CycleCountInstructions: "Instructions: Select area. Use 'Tab' and 'Up' & 'Down' arrow keys to navigate list. Press 'Enter' for 'Edit Mode', 'Esc' to exit 'Edit Mode'",
  coaBorderColors: ["#ff9999", "#FF0000", "#99ccff", "#99ffcc", "9999ff", "#6D4B9A", "#5AB7D4", "#006100", "#006BD1", "#009D76", "#006983", "#004B76", "#9FADBD", "#27847C", "#C07D99"],
  activeList: [
      {label: "Yes", value: true},
      //{label: "No", value: false}
    ],
  VerificationStatus: {
    NOT_VERIFIED: {value: null, label: "Not Verified"},
    AWAITING_VERIFICATION: {value: 1, label: "Awaiting Verification"},
    VERIFIED_WITH_CORRECTIVE_ACTION: {value: 2, label: "Verified with Corrective Action"},
    VERIFIED_WITH_FURTHER_INVESTIGATION_REQUIRED: {value: 3, label: "Verified with Further Investigation Required"}
    },
    REQUEST_STATUS: {
        PENDING: {label: "Pending", value: 1},
        IN_PROGRESS: {label: "In Progress", value: 2},
        COMPLETED: {label: "Completed", value: 3},
    },
    SHIPPING_TYPES: SHIPPING_TYPES,
    SHIPPING_TYPE_LIST: [
      SHIPPING_TYPES.Magento,
      SHIPPING_TYPES.Acumatica
    ]
}


// WEBPACK FOOTER //
// ./src/helpers/constant.js